import { Vector3 as Vector3Like } from '@react-three/fiber';
import { BufferGeometry, EdgesGeometry } from 'three';

/**
 * Extracts edge line segments from a `BufferGeometry`, using an `EdgesGeometry` under the hood. Because this
 *   `EdgesGeometry` is immediately disposed, there is no GPU time cost.
 */
export function extractEdgeSegments(geometry: BufferGeometry): { start: Vector3Like; end: Vector3Like }[] {
  const edgesGeometry = new EdgesGeometry(geometry);
  const positions = edgesGeometry.getAttribute('position');

  const segments: { start: Vector3Like; end: Vector3Like }[] = [];

  for (let i = 0; i < positions.count; i += 2) {
    segments.push({
      start: [positions.getX(i), positions.getY(i), positions.getZ(i)],
      end: [positions.getX(i + 1), positions.getY(i + 1), positions.getZ(i + 1)],
    });
  }

  edgesGeometry.dispose();

  return segments;
}
